"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const types_1 = require("../loading/types");
const actionCreators = __importStar(require("./actions"));
const initialState = {
    createdProject: null,
    isLoading: types_1.LOADING_STATE.COMPLETE,
    isDuplicating: false,
    isUpdatingCompleted: true,
    currentProject: null,
    viewMode: 'edit',
    project: null,
    showProjectDetailsPopover: false,
    duplicatedProject: null,
    isExportToStepLoading: false,
    exportProgress: {
        projectId: undefined,
        progress: 0,
    },
    exportQueue: [],
    isReplacingProjectItems: types_1.LOADING_STATE.COMPLETE,
    projectLoadingStage: null,
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    var _a, _b, _c;
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.getCurrentProject): {
            draft.currentProject = null;
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            draft.projectLoadingStage = 'project-data';
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.getCurrentProjectSuccess): {
            draft.isLoading = types_1.LOADING_STATE.COMPLETE;
            draft.currentProject = action.payload;
            draft.projectLoadingStage = null;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.getCurrentProjectFailed): {
            draft.isLoading = types_1.LOADING_STATE.FAILED;
            draft.projectLoadingStage = null;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setDefaultProjectFastener): {
            if (draft.currentProject) {
                draft.currentProject.defaultFasteners = action.payload;
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.createProjectSuccess): {
            draft.createdProject = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.duplicateProject): {
            if (action.payload.isDuplicatedProjectOpening) {
                draft.isLoading = types_1.LOADING_STATE.LOADING;
            }
            draft.isDuplicating = true;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.duplicateProjectSuccess): {
            draft.isLoading = types_1.LOADING_STATE.COMPLETE;
            draft.isDuplicating = false;
            draft.duplicatedProject = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.getProjectSuccess): {
            draft.project = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.editProjectSuccess): {
            draft.isUpdatingCompleted = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setProjectLoading):
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            break;
        case (0, typesafe_actions_1.getType)(actionCreators.setProjectLoadingStage):
            draft.projectLoadingStage = action.payload;
            break;
        case (0, typesafe_actions_1.getType)(actionCreators.toggleProjectDetailsPopover): {
            draft.showProjectDetailsPopover = action.payload;
            // eslint-disable-next-line no-useless-return
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setViewMode): {
            draft.viewMode = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.replaceCurrentProjectItemsAction): {
            draft.isReplacingProjectItems = types_1.LOADING_STATE.LOADING;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.replaceCurrentProjectItemsSuccess): {
            if (((_c = (_b = (_a = draft.currentProject) === null || _a === void 0 ? void 0 : _a.quotes) === null || _b === void 0 ? void 0 : _b[0].projectItems) === null || _c === void 0 ? void 0 : _c.length) && action.payload) {
                const { itemNumber: updatedItemNumber, uuids: replacedItemsUUIDs } = action.payload;
                draft.currentProject.quotes[0].projectItems.forEach((projectItem) => {
                    if (replacedItemsUUIDs.includes(projectItem.uuid)) {
                        projectItem.item.item_number = updatedItemNumber;
                    }
                });
            }
            draft.isReplacingProjectItems = types_1.LOADING_STATE.COMPLETE;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.replaceCurrentProjectItemsFailed): {
            draft.isReplacingProjectItems = types_1.LOADING_STATE.FAILED;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestSocketExportStep): {
            draft.isExportToStepLoading = true;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestSocketExportStepSuccess): {
            draft.isExportToStepLoading = false;
            draft.exportProgress = {
                progress: 0,
                projectId: undefined,
            };
            // eslint-disable-next-line no-useless-return
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestSocketExportStepProgress): {
            draft.exportProgress = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setExportQueue): {
            draft.exportQueue = action.payload;
            break;
        }
        default:
            break;
    }
});
exports.default = reducer;
